import { Quote } from "lucide-react";
import { Card } from "./ui/card";
import { useLanguage } from "@/i18n/LanguageContext";
import type { TranslationKey } from "@/i18n/translations";

// Curated testimonials most relevant to founder advisory work
const testimonials: { name: string; roleKey: TranslationKey; textKey: TranslationKey }[] = [
  { name: "Russell", roleKey: "testimonials.role.founder", textKey: "testimonials.russell" },
  { name: "Jacob", roleKey: "testimonials.role.accelerator", textKey: "testimonials.jacob" },
  { name: "Sofie", roleKey: "testimonials.role.founder", textKey: "testimonials.sofie" },
  { name: "Hayden", roleKey: "testimonials.role.mentee", textKey: "testimonials.hayden" },
  { name: "Zubair", roleKey: "testimonials.role.team", textKey: "testimonials.zubair" },
  { name: "Timothy", roleKey: "testimonials.role.partner", textKey: "testimonials.timothy" },
];

const TestimonialsSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-32 bg-gradient-to-br from-background via-secondary/30 to-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20 space-y-4">
            <h2 className="text-4xl sm:text-5xl font-bold tracking-tighter">
              {t("testimonials.title")}
            </h2>
            <div className="h-1 w-16 bg-accent mx-auto rounded-full" />
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              {t("testimonials.subtitle")}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <Card
                key={testimonial.name}
                className="p-8 bg-card/50 backdrop-blur-sm border-border/50 hover:border-accent/30 transition-all duration-300 hover:shadow-xl flex flex-col hover-lift rounded-sm"
              >
                <Quote className="h-6 w-6 text-accent/40 mb-6" />
                <blockquote className="flex-grow">
                  <p className="text-sm leading-relaxed text-foreground/80 mb-8">
                    "{t(testimonial.textKey)}"
                  </p>
                </blockquote>
                <footer className="mt-auto pt-6 border-t border-border/30">
                  <div className="font-bold text-foreground font-sans text-sm">
                    {testimonial.name}
                  </div>
                  <div className="text-xs text-muted-foreground mt-1">
                    {t(testimonial.roleKey)}
                  </div>
                </footer>
              </Card>
            ))}
          </div>

          <div className="mt-16 text-center">
            <p className="text-xs text-muted-foreground italic font-sans tracking-wide">
              {t("testimonials.footnote")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
